import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, XIcon } from "lucide-react";
import { ledgerEase } from "../utils/motion";
const navItems = [{
  to: "/services",
  label: "Services"
}, {
  to: "/payroll-operations",
  label: "Payroll"
}, {
  to: "/hr-technology",
  label: "HR Technology"
}, {
  to: "/research",
  label: "Research"
}, {
  to: "/ledger",
  label: "The Ledger"
}, {
  to: "/about",
  label: "About"
}];
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <header className="sticky top-0 z-40 border-b border-stone bg-ivory/95 backdrop-blur-sm" data-id="element-651" data-mp="zwah6wn1l0x8">
      <div className="shell flex h-20 items-center justify-between gap-8" data-id="element-652" data-mp="2gash9fbo7oxo">
        <Link to="/" aria-label="Constant — home" className="font-display text-[26px] leading-none tracking-[0.07em] text-navy" data-id="element-653" data-mp="2bcr04zxt1zou">
          CONSTANT
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-6 xl:flex 2xl:gap-8" data-id="element-654" data-mp="2ein5a0pirfc1">
          {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
          isActive
        }) => `relative whitespace-nowrap py-2 text-[13px] font-medium tracking-[0.04em] transition-colors duration-150 ease-ledger hover:text-oxblood ${isActive ? "text-oxblood" : "text-charcoal/80"}`} data-id="element-655" data-mp="2jjb3b6c60wfr">
              {({
            isActive
          }) => <>
                  {item.label}
                  {isActive && <span aria-hidden className="absolute -bottom-px left-0 right-0 h-px bg-oxblood" data-id="element-656" data-mp="25ja1noo2tkz8" />}
                </>}
            </NavLink>)}
        </nav>

        <div className="flex items-center gap-4" data-id="element-657" data-mp="1d1e4cxwfqzdv">
          <Link to="/contact" className="btn-primary hidden h-11 xl:inline-flex" data-id="element-658" data-mp="1d0306wz2vpm8">
            Talk to Us
          </Link>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? "Close menu" : "Open menu"} className="flex h-11 w-11 items-center justify-center text-navy xl:hidden" data-id="element-659" data-mp="10250yvowr9tb">
            {open ? <XIcon className="h-5 w-5" strokeWidth={1.25} data-id="element-660" data-mp="m1khryf2zbza" /> : <MenuIcon className="h-5 w-5" strokeWidth={1.25} data-id="element-661" data-mp="m4gfpmqxi0nq" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-662" data-mp="h5nccn5cvq1a">
        {open && <motion.nav id="mobile-nav" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: ledgerEase
      }} className="border-t border-stone bg-ivory xl:hidden" data-id="element-663" data-mp="w0tgt5oszgsi">
            <ul className="shell py-4" data-id="element-664" data-mp="22iq76pqgw5is">
              {navItems.map(item => <li key={item.to} className="border-b border-stone last:border-b-0" data-id="element-665" data-mp="29ytn6rjbag6b">
                  <NavLink to={item.to} className={({
              isActive
            }) => `block py-4 font-display text-2xl ${isActive ? "text-oxblood" : "text-navy"}`} data-id="element-666" data-mp="2f00zn3weg3jb">
                    {item.label}
                  </NavLink>
                </li>)}
              <li className="pt-6" data-id="element-667" data-mp="2xppku5ag85lh">
                <Link to="/contact" className="btn-primary w-full" data-id="element-668" data-mp="2xoo0fa7jm6r3">
                  Talk to Us
                </Link>
              </li>
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}